import React, { useEffect } from 'react';
import { useMonitoring, useSellerData, SellerPageFederatedSeller } from '@fiverr-private/seller_pages_toolbox';
import { RolePageClients } from './RolePageClients';

export const RolePageClientsResolver = () => {
    const { fireEvents, Providers } = useMonitoring();
    const { notableClients } = useSellerData(selectSellerSlice);

    const hasClients = notableClients.length > 0;

    useEffect(() => {
        if (hasClients) {
            fireEvents({
                [Providers.Mixpanel]: {
                    type: 'Notable client exist',
                },
            });
        }
    }, [Providers.Mixpanel, fireEvents, hasClients]);

    if (hasClients) {
        return <RolePageClients />;
    }

    return null;
};

export const selectSellerSlice = (seller: SellerPageFederatedSeller) => ({
    notableClients: seller.notableClients,
});

export default RolePageClientsResolver;
